<div class="prospecto-summary" [class.new-style]="style() === 'new'">
  <!-- Header del prospecto -->
  <div class="prospecto-header">
    <div class="prospecto-header-content">
      <span class="prospecto-nombre">{{ displayName() }}</span>
      @if (tipoActividad()) {
      <span class="prospecto-actividad">{{ tipoActividad() }}</span>
      }
      <div class="prospecto-actions">
        @if (loadingIcons()) {
        <div class="icons-loading"></div>
        } @else {
        @for (icon of tableroIcons(); track icon.iconName) {
        <button class="action-btn" (click)="onIconClick(icon)" [title]="icon.tooltip">
          <app-icon [icon]="$any(icon.iconName)" size="2rem" color="--white" />
        </button>
        }
        }
      </div>
    </div>
    <div class="prospecto-header-icon">
      <app-icon [icon]="$any('account-group')" size="3rem" color="--secondary" />
    </div>
  </div>

  <!-- Loading -->
  @if (loading()) {
  <div class="loading-container">
    <div class="spinner"></div>
    <span>Cargando datos...</span>
  </div>
  } @else {
  <!-- Acordeones -->
  <div class="accordions-container">
    <!-- Datos del prospecto -->
    <app-accordion title="Datos del prospecto" icon="mdi-contact-info" [style]="style()" [isOpen]="isAccordionOpen('datos-prospecto')"
      (toggle)="toggleAccordion('datos-prospecto')">
      <app-data-table [rows]="getDatosProspectoRows()" />
    </app-accordion>

    <!-- Datos de comunicación -->
    <app-accordion title="Datos de comunicación" icon="handshake-outline" [style]="style()"
      [isOpen]="isAccordionOpen('datos-comunicacion')" (toggle)="toggleAccordion('datos-comunicacion')">
      <app-data-table [rows]="getDatosComunicacionRows()" />
      @if (getCanalesHabilitados().length > 0) {
      <div class="canales-row">
        <span class="canales-label">Canales</span>
        <div class="canales-icons">
          @for (canal of getCanalesHabilitados(); track canal.tipo) {
          <button class="canal-icon-btn" (click)="onCanalClick(canal.urlAccion)"
            [title]="canal.etiqueta + ': ' + canal.valor">
            <app-icon [icon]="$any(canal.icon)" size="2.4rem" color="--primary" />
          </button>
          }
        </div>
      </div>
      }
    </app-accordion>

    <!-- Oportunidad de venta -->
    <app-accordion title="Oportunidad de venta" icon="car" [style]="style()" [isOpen]="isAccordionOpen('oportunidad-venta')"
      (toggle)="toggleAccordion('oportunidad-venta')">
      <app-data-table [rows]="getOportunidadVentaRows()" />
    </app-accordion>

    <!-- Resumen de seguimientos -->
    <app-accordion title="Resumen de seguimientos" icon="rotate-right" [style]="style()"
      [isOpen]="isAccordionOpen('resumen-seguimientos')" (toggle)="toggleAccordion('resumen-seguimientos')">
      <div class="seguimientos-list">
        @if (getSeguimientos().length === 0) {
        <p class="empty-message">Sin seguimientos</p>
        } @else {
        @for (seg of getSeguimientos(); track seg.idSeguimiento) {
        <div class="seguimiento-item" [class.cumplido]="isSeguimientoCumplido(seg)"
          [class.pendiente]="!isSeguimientoCumplido(seg)">
          <div class="flex items-center gap-2">
            @if (isSeguimientoCumplido(seg)) {
            <app-icon [icon]="$any('check-circle-outline')" size="2.5rem" color="--success" />
            }
            <div class="seguimiento-info" [class.with-icon]="isSeguimientoCumplido(seg)">
              <span class="seguimiento-fecha">{{ formatDate(seg.programada) }}</span>
              <span class="seguimiento-actividad">{{ seg.tipoActividadDetalle }}</span>
            </div>
          </div>
          <span class="seguimiento-ejecutivo">{{ seg.ejecutivo }}</span>
          @if (!isSeguimientoCumplido(seg)) {
          <div class="seguimiento-actions">
            <span class="badge-pendiente">Pendiente</span>
            <button class="btn-cumplir" (click)="onCumplirSeguimiento(seg)">
              Cumplir
              <app-icon [icon]="$any('check-circle-outline')" size="1.8rem" color="--secondary" />
            </button>
          </div>
          }
        </div>
        }
        }
      </div>
    </app-accordion>


    <!-- Bitacora de privacidad -->
    <app-accordion title="Bitácora de privacidad" icon="account-lock-open-outline" [style]="style()"
      [isOpen]="isAccordionOpen('bitacora-privacidada')" (toggle)="toggleAccordion('bitacora-privacidada')">
      <div class="bitacora-list">
        @if (bitacoraPrivacidad().length === 0) {
        <p class="empty-message">Sin registros</p>
        } @else {
        @for (item of bitacoraPrivacidad(); track item.Registro) {
        <div class="bitacora-item">
          <span class="bitacora-fecha">{{ formatDateTime(item.Registro) }}</span>
          <app-badge [type]="item.Privacidad ? 'success' : 'danger'" [text]="item.Privacidad ? 'SI' : 'NO'" />
        </div>
        }
        }
      </div>
    </app-accordion>

    <!-- Historial de ventas -->
    <app-accordion title="Historial de ventas" icon="store-clock" [style]="style()" [isOpen]="isAccordionOpen('historial-ventas')"
      (toggle)="toggleAccordion('historial-ventas')">
      <div class="demos-container">
        @if (historialVentas().length === 0) {
        <p class="empty-message">Sin registros</p>
        } @else {
        <div class="demos-navigation">
          <button class="nav-btn" (click)="prevVenta()" [disabled]="ventaIndex() === 0">
            <app-icon [icon]="$any('chevron-left')" size="3rem"
              [color]="ventaIndex() === 0 ? '--gray' : '--secondary'" />
          </button>
          <div class="demos-content">
            <app-data-table [rows]="getCurrentVentaRows()" />
          </div>
          <button class="nav-btn" (click)="nextVenta()" [disabled]="ventaIndex() >= getTotalVentas() - 1">
            <app-icon [icon]="$any('chevron-right')" size="3rem"
              [color]="ventaIndex() >= getTotalVentas() - 1 ? '--gray' : '--secondary'" />
          </button>
        </div>
        <div class="demos-counter">
          {{ ventaIndex() + 1 }} de {{ getTotalVentas() }}
        </div>
        }
      </div>
    </app-accordion>

    <!--Historial de valuaciones -->
    <app-accordion title="Historial de valuaciones" icon="car-info" [style]="style()" [isOpen]="isAccordionOpen('historial-valuaciones')"
      (toggle)="toggleAccordion('historial-valuaciones')">
      <div class="demos-container">
        @if (historialValuaciones().length === 0) {
        <p class="empty-message">Sin registros</p>
        } @else {
        <div class="demos-navigation">
          <button class="nav-btn" (click)="prevValuacion()" [disabled]="valuacionIndex() === 0">
            <app-icon [icon]="$any('chevron-left')" size="3rem"
              [color]="valuacionIndex() === 0 ? '--gray' : '--secondary'" />
          </button>
          <div class="demos-content">
            <app-data-table [rows]="getCurrentValuacionRows()" />
          </div>
          <button class="nav-btn" (click)="nextValuacion()" [disabled]="valuacionIndex() >= getTotalValuaciones() - 1">
            <app-icon [icon]="$any('chevron-right')" size="3rem"
              [color]="valuacionIndex() >= getTotalValuaciones() - 1 ? '--gray' : '--secondary'" />
          </button>
        </div>
        <div class="demos-counter">
          {{ valuacionIndex() + 1 }} de {{ getTotalValuaciones() }}
        </div>
        }
      </div>
    </app-accordion>

    <!--Historial de demos -->
    <app-accordion title="Historial de demos" icon="car-key" [style]="style()" [isOpen]="isAccordionOpen('historial-demos')"
      (toggle)="toggleAccordion('historial-demos')">
      <div class="demos-container">
        @if (historialDemos().length === 0) {
        <p class="empty-message">Sin registros</p>
        } @else {
        <div class="demos-navigation">
          <button class="nav-btn" (click)="prevDemo()" [disabled]="demoIndex() === 0">
            <app-icon [icon]="$any('chevron-left')" size="3rem"
              [color]="demoIndex() === 0 ? '--gray' : '--secondary'" />
          </button>
          <div class="demos-content">
            <app-data-table [rows]="getCurrentDemoRows()" />
          </div>
          <button class="nav-btn" (click)="nextDemo()" [disabled]="demoIndex() >= getTotalDemos() - 1">
            <app-icon [icon]="$any('chevron-right')" size="3rem"
              [color]="demoIndex() >= getTotalDemos() - 1 ? '--gray' : '--secondary'" />
          </button>
        </div>
        <div class="demos-counter">
          {{ demoIndex() + 1 }} de {{ getTotalDemos() }}
        </div>
        }
      </div>
    </app-accordion>

    <!--Historial de adjuntos -->
    <app-accordion title="Historial de adjuntos" icon="file-document-outline" [style]="style()"
      [isOpen]="isAccordionOpen('historial-adjuntos')" (toggle)="toggleAccordion('historial-adjuntos')">
      <div class="demos-container">
        @if (historialAdjuntos().length === 0) {
        <p class="empty-message">Sin registros</p>
        } @else {
        <div class="demos-navigation">
          <button class="nav-btn" (click)="prevAdjunto()" [disabled]="adjuntoIndex() === 0">
            <app-icon [icon]="$any('chevron-left')" size="3rem"
              [color]="adjuntoIndex() === 0 ? '--gray' : '--secondary'" />
          </button>
          <div class="demos-content">
            <app-data-table [rows]="getCurrentAdjuntoRows()" />
          </div>
          <button class="nav-btn" (click)="nextAdjunto()" [disabled]="adjuntoIndex() >= getTotalAdjuntos() - 1">
            <app-icon [icon]="$any('chevron-right')" size="3rem"
              [color]="adjuntoIndex() >= getTotalAdjuntos() - 1 ? '--gray' : '--secondary'" />
          </button>
        </div>
        <div class="demos-counter">
          {{ adjuntoIndex() + 1 }} de {{ getTotalAdjuntos() }}
        </div>
        }
      </div>
    </app-accordion>

  </div>
  }
</div>
